/**
 * brandLogo.ts - Product brand shown in the sidebar (left of "Chats").
 *
 * The Chat AI logo, bundled in the app's public dir and imported so Vite rewrites
 * it under the app base (/static/apps/sessions/chat-ai-logo.png) — resolves in dev
 * (standalone Vite server) and prod alike.
 */
import chatAiLogo from '/chat-ai-logo.png'

export const brandLogoSrc = (): string => chatAiLogo
